<template>
  <v-dialog :value="isLoading" persistent fullscreen :transition="false">
    <div class="auth-loading">
      <v-progress-circular indeterminate size="120" />
    </div>
  </v-dialog>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import userStore from '../../auth.store'
import { getModule } from 'vuex-module-decorators'

@Component
export default class AuthDialog extends Vue {
  userModule = getModule(userStore, this.$store)

  get isLoading() {
    return this.userModule.isLoading
  }
}
</script>

<style scoped lang="scss">
.auth-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--100vh);
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
